import { Tag, TagProps } from 'antd';
import './style.scss';

export interface TagComponentProps extends TagProps {
  label?: string;
  className?: string;
  type?: 'green' | 'red';
  textColor?: string;
}

const TagComponent = ({
  color,
  label,
  className,
  type,
  textColor,
  ...props
}: TagComponentProps) => {
  return (
    <Tag
      className={`tag${className ? ' ' + className : ''}${type ? ' ' + type : ''}`}
      color={color}
      style={textColor ? { color: textColor } : undefined}
      {...props}
    >
      {label?.toString()?.toLowerCase()}
    </Tag>
  );
};

export default TagComponent;
